module.exports = __webpack_public_path__ + "img/pdgt_rent.3f67c908.jpg";